/**
 * @internal
 * Loading skeleton rendered by LineChart while data is fetching. Not part of the public API.
 * Use `LineChart` instead — it handles loading, empty, and rendered states automatically.
 */
import React, { forwardRef, RefObject } from 'react';

import { LineChartProps } from './types';
import { StyledLineChart } from './styles';

export const LoadingLineChart = forwardRef<HTMLDivElement, LineChartProps>((props, ref) => {
  const { className, ...forwardedProps } = props;

  return (
    <StyledLineChart {...forwardedProps} className={className} ref={ref as RefObject<HTMLDivElement>}>
      Loading...
    </StyledLineChart>
  );
});
